module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_diamond_grey_1.64c2657b.png";